import { createContext } from "react";

export const ShipDocContext = createContext({
  shipDoc: {},
  onChange: () => {},
});
